import SectionHeading from './SectionHeading';
import { recentUpdates } from '@/mocks/mikami/recentUpdates';

const toneStyles: Record<string, { dot: string; badge: string }> = {
  primary: { dot: 'bg-primary-500', badge: 'bg-primary-100 text-primary-700' },
  accent: { dot: 'bg-accent-500', badge: 'bg-accent-100 text-accent-800' },
  secondary: { dot: 'bg-secondary-500', badge: 'bg-secondary-100 text-secondary-900' },
};

const focusPoints = [
  { icon: 'ri-film-line', title: '新片脉络', desc: '先按题材归类，再给观看顺序建议。' },
  { icon: 'ri-image-2-line', title: '写真与影像', desc: '按色调、场景与质感划分合集。' },
  { icon: 'ri-calendar-event-line', title: '活动方向', desc: '线下、线上与合作联动分类归档。' },
  { icon: 'ri-shield-check-line', title: '消息核对', desc: '区分官方发布与二次转述内容。' },
];

export default function RecentSection() {
  return (
    <section id="recent" className="anchor-offset bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="最新近况"
          title="近期更新与近况方向"
          description="近况按作品、写真、活动三条线索汇总。下面按整理顺序列出近期的主要变化，先给整体节奏，再指向对应分区，方便按线索继续深入。"
        />

        <div className="grid gap-6 lg:grid-cols-[1.15fr_0.85fr]">
          <ol className="relative space-y-5 border-l border-background-300 pl-6">
            {recentUpdates.map((item) => {
              const tone = toneStyles[item.tone] ?? toneStyles.primary;
              return (
                <li key={item.id} className="relative">
                  <span className={`absolute -left-[31px] top-2 h-3 w-3 rounded-full ring-4 ring-background-50 ${tone.dot}`}></span>
                  <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded-full px-2.5 py-0.5 text-xs font-label ${tone.badge}`}>{item.type}</span>
                      <span className="text-xs text-foreground-500">{item.period}</span>
                    </div>
                    <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  </div>
                </li>
              );
            })}
          </ol>

          <aside className="h-fit rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-focus-3-line text-primary-500"></i>
              关注重点
            </h3>
            <ul className="mt-4 space-y-3">
              {focusPoints.map((point) => (
                <li key={point.title} className="flex gap-3 rounded-md bg-background-50 p-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${point.icon} text-base`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-label text-foreground-900">{point.title}</p>
                    <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">{point.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
            <p className="mt-4 rounded-md border border-secondary-200 bg-secondary-50 p-3 text-xs leading-relaxed text-secondary-900">
              <i className="ri-information-line mr-1"></i>
              页面内容为一般性整理，涉及具体时间、场次与发布细节时，请以官方渠道公布为准。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}